import { assert } from '../../lib/assert-sidecar'
import { l } from '../../lib/imports'
import { rando } from '../../lib/rando-sidecar'
import { createId } from '../../main/common'
import { chessGameRules } from './chessGameRules-sidecar'
import { EChessTeam } from './chessPieces'
import { EChessPieceType } from './chessPiecesData'
import { chessMessagePieceCreate } from './messages/chessMessagePieceCreate-sidecar'
import { chessWebsockets } from './messages/chessWebsockets-sidecar'

export const isRotated = true

const getTeams = () => {
  if (isRotated) {
    return { t1: EChessTeam.Black, t2: EChessTeam.White }
  } else {
    return { t1: EChessTeam.White, t2: EChessTeam.Black }
  }
}

const namespace = 'chess-layout-board'
const energy = 999
const placeTime = () => {
  return chessGameRules.get().layoutDelay
}
export function* generator_layoutBoard(): Generator<number, number, number> {
  console.log(namespace, 'layout board')

  if (chessWebsockets.getIsHost()) {
    const layoutNormal = () => {
      return layoutRandomBoard(0)
    }
    const layoutSym = () => {
      return layoutRandomBoard(1)
    }
    const layoutAsym = () => {
      return layoutRandomBoard(2)
    }
    const layoutBlockSym = () => {
      return layoutRandomBlock(1)
    }
    const layoutBlockAsym = () => {
      return layoutRandomBlock(2)
    }
    // let layoutFuncs = [layoutNormal, layoutSym, layoutAsym]
    let layoutFuncs = [
      layoutNormal,
      layoutSym,
      layoutAsym,
      layoutBlockSym,
      layoutBlockAsym,
    ]
    let layoutFunc = rando.sample(layoutFuncs)
    yield* layoutFunc()
  }

  return 0
}

export function* layoutRandomBoard(
  numShuffles: number,
): Generator<number, number, number> {
  let piecesFront = [
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
  ]

  let piecesBack = [
    EChessPieceType.Rook,
    EChessPieceType.Knight,
    EChessPieceType.Bishop,
    EChessPieceType.King,
    EChessPieceType.Queen,
    EChessPieceType.Bishop,
    EChessPieceType.Knight,
    EChessPieceType.Rook,
  ]

  const shuffle = () => {
    piecesFront = rando.shuffle(piecesFront)
    piecesBack = rando.shuffle(piecesBack)
  }

  if (numShuffles >= 1) {
    shuffle()
  }

  let { t1, t2 } = getTeams()

  yield* layoutNormalRow(0, piecesBack, t1)
  yield* layoutNormalRow(1, piecesFront, t1)

  if (numShuffles >= 2) {
    shuffle()
  }

  yield* layoutNormalRow(8 - 1, piecesBack, t2)
  yield* layoutNormalRow(8 - 2, piecesFront, t2)

  return 0
}

export function* layoutRandomBlock(
  numShuffles: number,
): Generator<number, number, number> {
  let piecesFront = [
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
    EChessPieceType.Pawn,
  ]

  let piecesBackAll = [
    EChessPieceType.Rook,
    EChessPieceType.Knight,
    EChessPieceType.Bishop,
    EChessPieceType.King,
    EChessPieceType.Queen,
    EChessPieceType.Bishop,
    EChessPieceType.Knight,
    EChessPieceType.Rook,
  ]
  let piecesBack1: EChessPieceType[] = []
  let piecesBack2: EChessPieceType[] = []

  const shuffle = () => {
    let p = l.cloneDeep(piecesBackAll)
    piecesBack1 = []
    piecesBack2 = []
    for (let i = 0; i < 4; i++) {
      piecesBack1.push(rando.sampleAndRemove(p))
      piecesBack2.push(rando.sampleAndRemove(p))
    }
  }

  //if (numShuffles >= 1) {
  shuffle()
  //}

  let { t1, t2 } = getTeams()

  yield* layoutBlock(0, piecesBack1, t1)
  yield* layoutBlock(1, piecesBack2, t1)
  yield* layoutBlock(2, piecesFront, t1)

  if (numShuffles >= 2) {
    shuffle()
  }

  yield* layoutBlock(8 - 1, piecesBack1, t2)
  yield* layoutBlock(8 - 2, piecesBack2, t2)
  yield* layoutBlock(8 - 3, piecesFront, t2)

  return 0
}

export function* layoutNormalRow(
  i: number,
  pieces: EChessPieceType[],
  team: EChessTeam,
): Generator<number, number, number> {
  assert.eq(pieces.length, 8)
  let p = l.cloneDeep(pieces)

  for (let j = 0; j < 8; j++) {
    let i2 = i
    let j2 = j
    if (isRotated) {
      let c = j2
      j2 = i2
      i2 = c
    }

    let t = p[j] //rando.sampleAndRemove(p)
    if (t !== EChessPieceType.Null) {
      chessMessagePieceCreate.sendMessageAndImmediatelyExecute({
        pieceId: createId(),
        team: team,
        type: t,
        i: i2,
        j: j2,
        energy,
      })
      yield placeTime()
    }
  }
  return 0
}

export function* layoutBlock(
  i: number,
  pieces: EChessPieceType[],
  team: EChessTeam,
): Generator<number, number, number> {
  // console.log('layout block', i, pieces)
  assert.eq(pieces.length, 4, pieces, i)
  let p = l.cloneDeep(pieces)

  for (let j = 0; j < 4; j++) {
    let t = p[j] //rando.sampleAndRemove(p)

    let i2 = i
    let j2 = j + 2
    if (isRotated) {
      let c = j2
      j2 = i2
      i2 = c
    }

    if (t !== EChessPieceType.Null) {
      chessMessagePieceCreate.sendMessageAndImmediatelyExecute({
        pieceId: createId(),
        team: team,
        type: t,
        i: i2,
        j: j2,
        energy,
      })
      yield placeTime()
    }
  }
  return 0
}
